import { createGlobalStyle } from 'styled-components'
import {
  mediaMax,
  calculateResponsiveSize,
  calculateMobileResponsiveSize,
} from 'styles/media-queries'

const GlobalStyle = createGlobalStyle`
  :root {
    --beige: #F4E1D4;
    --brick: #581F0C;
    --flower: #779AE5;
    --orange: #FF6231;
  }
  li {
    list-style: none;
  }
  * {
    margin: 0;
    padding: 0;
    font-family: inherit;
    box-sizing: border-box;
  }
  body {
    width: 100%;
    height: 100%;
    font-family: "MrEavesXLModOT";
    font-size: ${calculateResponsiveSize(12)};
    font-weight: 400;
    line-height: ${calculateResponsiveSize(16)};
    text-align: center;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: var(--beige);
    letter-spacing: 0;

    color: var(--brick);
   
    min-width: 320px;
    overflow-y: scroll;
    ${mediaMax('mobile')} {
      font-size: ${calculateMobileResponsiveSize(12)};
      line-height: ${calculateMobileResponsiveSize(19.2)};
    }
  }
  body.hidden {
    height: 100dvh !important;
  }
  body.hidden .home-wrapper {
    height: 100dvh;
    overflow: hidden;
  }

  a, a:hover, a:active, a:visited {
    color: var(--brick);
    text-decoration: none;

    
  }
  .home-content {
     will-change: transform; 
  }
  
  
  .portal {
    position: fixed;
    inset: 0px;
    z-index: 106;
    display: flex;
    justify-content: center;
  }
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;

    }
  }

  .mob-only{
    display: none !important;
  }
  ${mediaMax('mobile')} {
    .web-only{
      display: none !important;
    }
    .mob-only{
      display: block !important;
    }
  }

  /* ----- UserWay ----- */
  body .uwy {
    opacity: 0;
    visibility: hidden;
    animation: 2s ease 10s normal forwards 1 fadeIn;

    & #userwayAccessibilityIcon{
      width: ${calculateResponsiveSize(35)};
      height: ${calculateResponsiveSize(35)};
      box-shadow: 0px 0px ${calculateResponsiveSize(12)} 0px #FFFFFF40;

      ${mediaMax('mobile')} {
        width: ${calculateMobileResponsiveSize(30)};
        height: ${calculateMobileResponsiveSize(30)};
        box-shadow: 0px 0px ${calculateMobileResponsiveSize(12)} 0px #FFFFFF40;
      }
    }
    @keyframes fadeIn {
      0% {
        opacity: 0;
        visibility: hidden;
      }
      100% {
        opacity: 1;
        visibility: visible;
      }
    }
  }
  body .uwy > .userway_buttons_wrapper  {
    top: auto !important;
    bottom: ${calculateResponsiveSize(7)} !important;
    left: ${calculateResponsiveSize(7)} !important;
    right: auto !important;
    transform: none !important;
    ${mediaMax('mobile')} {
      bottom: ${calculateMobileResponsiveSize(15)} !important;
      left: ${calculateMobileResponsiveSize(20)} !important;
    }
  }
`

export default GlobalStyle
